import { postReq, createUrl } from '@/infra/http';
import { uploadResponseModel, uploadToStorageModel } from '@/models/storage.model';

export const uploadToStorage = async (req: uploadToStorageModel): Promise<string> => {
    const formData = new FormData();
    formData.append("File", req.file);
    formData.append("Category", req.category.toString());
    if(req.type) {
        formData.append("Type", req.type.toString());
    }
    return await postReq(createUrl("a/Storage"),
        formData
    ).then((res: any) => res.data.result);
};

export const uploadToStorage_v2 = async (req: uploadToStorageModel): Promise<uploadResponseModel> => {
    const formData = new FormData();
    formData.append("File", req.file);
    formData.append("Category", req.category.toString());
    if(req.type) {
        formData.append("Type", req.type.toString());
    }
    return await postReq(createUrl("a/Storage/V2/Upload"),
        formData
    ).then((res: any) => res.data.result);
};
